/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Rolefilters1Inputs */

const en_nav_rolefilters1 = /** @type {(inputs: Nav_Rolefilters1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Filters`)
};

const de_nav_rolefilters1 = /** @type {(inputs: Nav_Rolefilters1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollenfilter`)
};

/**
* | output |
* | --- |
* | "Role Filters" |
*
* @param {Nav_Rolefilters1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_rolefilters1 = /** @type {((inputs?: Nav_Rolefilters1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Rolefilters1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_rolefilters1(inputs)
	return de_nav_rolefilters1(inputs)
});
export { nav_rolefilters1 as "nav_roleFilters" }